module.exports = __webpack_public_path__ + "static/media/canada01.63dc9d91.jpg";